<script>
import tableMixin from './table'

export default {
  mixins: [tableMixin],
  computed: {
    archived () {
      const archivedView = this.$store.state[this.namespace]._archivedView
      return this.view === archivedView
    }
  },
  methods: {
    rowClicked (item) {
      if (this.rowClickEnabled) {
        this.$router.push({
          name: this.rowClickRoute,
          params: {
            [this.routeParamName]: item.id
          }
        })
      }
    },
    removeAll () {
      this.$emit('removeAll')
    },
    edit (id) {
      this.$router.push({
        name: this.editRoute,
        params: {
          [this.routeParamName]: id
        }
      })
    },
    restore (id) {
      this.$store.dispatch(`${this.namespace}/restore`, id)
    },
    archive (id) {
      this.$store.dispatch(`${this.namespace}/archive`, id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/mixins/admin-table.vue